const n = "{{currentTime}} od {{duration}}", o = "Rezultat iskanja {{current}} od {{total}}", t = "Ni rezultatov.", s = "{{count}} najden rezultat", a = "Najdenih {{count}} rezultatov", e = 'Predvajanje od $t(HOURS, { "count": {{hours}} }), $t(MINUTES, { "count": {{minutes}} }) in $t(SECONDS, { "count": {{seconds}} }).', i = 'Predvajanje od $t(MINUTES, { "count": {{minutes}} }) in $t(SECONDS, { "count": {{seconds}} }).', c = 'Predvajanje od $t(SECONDS, { "count": {{seconds}} }).', A = "Napaka pri shranjevanju sprememb v prepisu.", E = "Vrstica prepisa na {{time}}. Vsebina je: {{text}}.", T = 'Vsebnik vrstic prepisa. V tem vsebniku je $t(TRANSCRIPT_LINES, { "count": {{count}} }) . Za krmarjenje po tem vsebniku uporabite puščično tipko navzdol.', _ = "Shranjujem spremembe ...", S = "Spremembe so shranjene v prepis.", N = "Gumb za posodobitev podnapisov je zdaj na voljo.", r = "Dejanje", j = "Dodaj opombo pri {{time}}", R = "Dodaj vprašanje pri {{time}}", O = "Opombe", I = "Samodejno", p = "Samodejno ({{quality}})", P = "Nazaj", C = "Podnapisi", u = "Jezik napisov", v = "Upravljaj podnapise", d = "Izbriši {{language}}", U = "Velikost pisave", L = "Jezik napisov: {{language}}", D = "{{language}} (samodejno)", k = "Počisti iskanje", l = "Zapri", m = "Komentarji", M = "Nadaljuj", z = "Zmanjšaj hitrost predvajanja", G = "Zmanjšaj glasnost za {{percent}}%", Y = "Puščica za pomik navzdol", b = "Zapri urejevalnik prepisa", V = "Posodobi podnapise", H = "Napaka.", B = "Shranjevanje ...", h = "Shranjeno.", g = "Uredi prepis", K = "Besedilo ne sme biti prazno!", Z = "Celoten zaslon", F = "{{count}} ura", J = "{{count}} ur(i/e)", W = "Povečaj hitrost predvajanja", $ = "Povečaj glasnost za {{percent}}%", Q = "Barvni negativ", x = "Skoči na določen odstotek (1–10 %, 2–20 % itd.)", X = "Skoči na začetek", f = "Dejanja za {{title}}", q = "Bližnjice", y = "Jezik", w = "Puščica za pomik v levo", nn = "Glavni meni", on = "{{count}} minuta", tn = "{{count}} minut(i/e)", sn = "Onemogoči sprotno obveščanje", an = "Brez sprotnega obveščanja", en = "Naslednji jezik napisov", cn = "Naslednji rezultat iskanja", An = "Izključeno", En = "Na vrh", Tn = "Odpri opombo pri {{time}}", _n = "Odpri zaključen kviz pri {{time}}", Sn = "Odpri kviz pri {{time}}", Nn = "Začasna zaustavitev", rn = "Predvajaj", jn = "Hitrost predvajanja", Rn = "Hitrost predvajanja: {{speed}}x", On = "Prejšnji jezik napisov", In = "Prejšnji rezultat iskanja", pn = "Kakovost", Pn = "Meni kakovosti", Cn = "Ponovno predvajaj", un = "Ponastavi hitrost predvajanja", vn = "Puščica desno", dn = "Iskanje v prepisu", Un = "{{count}} sekunda", Ln = "{{count}} sekund(i/e)", Dn = "Iskanje nazaj: {{seconds}} sekund", kn = "Iskanje naprej: {{seconds}} sekund", ln = "Nastavitve", mn = "Bližnjica", Mn = "Podrobnosti in orodja za medij", zn = "Razmik", Gn = "Meni hitrosti predvajanja", Yn = "Začni samodejno pomikanje", bn = "Preklop med napisi", Vn = "Preklop utišanja zvoka", Hn = "Preklop predvajanja/premora", Bn = "je {{count}} vrstica prepisa", hn = "je {{count}} vrstic prepisa", gn = "Nalaganje prepisa ...", Kn = "Prepisa ni bilo mogoče naložiti.", Zn = "Možnosti prepisa", Fn = "Ponovno poskusi", Jn = "Prepis ni na voljo", Wn = "Puščica navzgor", $n = "Videonastavitve", Qn = "Glasnost", xn = "Glasnost: {{volume}}%", Xn = {
  A11Y_DURATION: n,
  A11Y_SEARCH_HITS: o,
  A11Y_SEARCH_NO_RESULTS: t,
  A11Y_SEARCH_RESULTS_FOUND: s,
  A11Y_SEARCH_RESULTS_FOUND_other: a,
  A11Y_TIMESTAMP_JUMP_HOURS: e,
  A11Y_TIMESTAMP_JUMP_MINUTES: i,
  A11Y_TIMESTAMP_JUMP_SECONDS: c,
  A11Y_TRANSCRIPT_ERROR: A,
  A11Y_TRANSCRIPT_LINE: E,
  A11Y_TRANSCRIPT_LINES: T,
  A11Y_TRANSCRIPT_SAVING: _,
  A11Y_TRANSCRIPT_SUCCESS: S,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: N,
  ACTION: r,
  ADD_ANNOTATION_AT: j,
  ADD_QUESTION_AT: R,
  ANNOTATIONS: O,
  AUTO: I,
  AUTO_QUALITY: p,
  BACK: P,
  CAPTIONS: C,
  CAPTIONS_LANGUAGE: u,
  CAPTIONS_MANAGE: v,
  CAPTION_DELETE: d,
  CAPTION_FONT_SIZE: U,
  CAPTION_LANGUAGE: L,
  CAPTION_LANGUAGE_AUTOMATIC: D,
  CLEAR_SEARCH: k,
  CLOSE: l,
  COMMENTS: m,
  CONTINUE: M,
  DECREASE_PLAYBACK_SPEED: z,
  DECREASE_VOLUME: G,
  DOWN_ARROW: Y,
  EDIT_CLOSE: b,
  EDIT_CONFIRM: V,
  EDIT_ERROR: H,
  EDIT_SAVING: B,
  EDIT_SUCCESS: h,
  EDIT_TRANSCRIPT: g,
  EDIT_VALIDATION_ERROR: K,
  FULLSCREEN: Z,
  HOURS: F,
  HOURS_other: J,
  INCREASE_PLAYBACK_SPEED: W,
  INCREASE_VOLUME: $,
  INVERT_COLORS: Q,
  JUMP_TO_PERCENTAGE: x,
  JUMP_TO_START: X,
  KEBAB_MENU: f,
  KEYBOARD_SHORTCUTS: q,
  LANGUAGE: y,
  LEFT_ARROW: w,
  MAIN_MENU: nn,
  MINUTES: on,
  MINUTES_other: tn,
  MUTE: sn,
  MUTED: an,
  NEXT_CAPTION_LANGUAGE: en,
  NEXT_HIT: cn,
  OFF: An,
  ON_TOP: En,
  OPEN_ANNOTATION_AT: Tn,
  OPEN_COMPLETED_QUIZ_AT: _n,
  OPEN_QUIZ_AT: Sn,
  PAUSE: Nn,
  PLAY: rn,
  PLAYBACK_SPEED: jn,
  PLAYBACK_SPEED_MESSAGE: Rn,
  PREVIOUS_CAPTION_LANGUAGE: On,
  PREVIOUS_HIT: In,
  QUALITY: pn,
  QUALITY_MENU: Pn,
  REPLAY: Cn,
  RESET_PLAYBACK_SPEED: un,
  RIGHT_ARROW: vn,
  SEARCH_TRANSCRIPT_PLACEHOLDER: dn,
  SECONDS: Un,
  SECONDS_other: Ln,
  SEEK_BACKWARD: Dn,
  SEEK_FORWARD: kn,
  SETTINGS: ln,
  SHORTCUT: mn,
  SIDEBAR: Mn,
  SPACE: zn,
  SPEED_MENU: Gn,
  START_AUTOSCROLL: Yn,
  TOGGLE_CAPTIONS: bn,
  TOGGLE_MUTED: Vn,
  TOGGLE_PLAY_PAUSE: Hn,
  TRANSCRIPT_LINES: Bn,
  TRANSCRIPT_LINES_other: hn,
  TRANSCRIPT_LOADING: gn,
  TRANSCRIPT_LOAD_ERROR: Kn,
  TRANSCRIPT_OPTIONS: Zn,
  TRANSCRIPT_RETRY: Fn,
  TRANSCRIPT_UNAVAILABLE: Jn,
  UP_ARROW: Wn,
  VIDEO_SETTINGS: $n,
  VOLUME: Qn,
  VOLUME_VALUE: xn
};
export {
  n as A11Y_DURATION,
  o as A11Y_SEARCH_HITS,
  t as A11Y_SEARCH_NO_RESULTS,
  s as A11Y_SEARCH_RESULTS_FOUND,
  a as A11Y_SEARCH_RESULTS_FOUND_other,
  e as A11Y_TIMESTAMP_JUMP_HOURS,
  i as A11Y_TIMESTAMP_JUMP_MINUTES,
  c as A11Y_TIMESTAMP_JUMP_SECONDS,
  A as A11Y_TRANSCRIPT_ERROR,
  E as A11Y_TRANSCRIPT_LINE,
  T as A11Y_TRANSCRIPT_LINES,
  _ as A11Y_TRANSCRIPT_SAVING,
  S as A11Y_TRANSCRIPT_SUCCESS,
  N as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  r as ACTION,
  j as ADD_ANNOTATION_AT,
  R as ADD_QUESTION_AT,
  O as ANNOTATIONS,
  I as AUTO,
  p as AUTO_QUALITY,
  P as BACK,
  C as CAPTIONS,
  u as CAPTIONS_LANGUAGE,
  v as CAPTIONS_MANAGE,
  d as CAPTION_DELETE,
  U as CAPTION_FONT_SIZE,
  L as CAPTION_LANGUAGE,
  D as CAPTION_LANGUAGE_AUTOMATIC,
  k as CLEAR_SEARCH,
  l as CLOSE,
  m as COMMENTS,
  M as CONTINUE,
  z as DECREASE_PLAYBACK_SPEED,
  G as DECREASE_VOLUME,
  Y as DOWN_ARROW,
  b as EDIT_CLOSE,
  V as EDIT_CONFIRM,
  H as EDIT_ERROR,
  B as EDIT_SAVING,
  h as EDIT_SUCCESS,
  g as EDIT_TRANSCRIPT,
  K as EDIT_VALIDATION_ERROR,
  Z as FULLSCREEN,
  F as HOURS,
  J as HOURS_other,
  W as INCREASE_PLAYBACK_SPEED,
  $ as INCREASE_VOLUME,
  Q as INVERT_COLORS,
  x as JUMP_TO_PERCENTAGE,
  X as JUMP_TO_START,
  f as KEBAB_MENU,
  q as KEYBOARD_SHORTCUTS,
  y as LANGUAGE,
  w as LEFT_ARROW,
  nn as MAIN_MENU,
  on as MINUTES,
  tn as MINUTES_other,
  sn as MUTE,
  an as MUTED,
  en as NEXT_CAPTION_LANGUAGE,
  cn as NEXT_HIT,
  An as OFF,
  En as ON_TOP,
  Tn as OPEN_ANNOTATION_AT,
  _n as OPEN_COMPLETED_QUIZ_AT,
  Sn as OPEN_QUIZ_AT,
  Nn as PAUSE,
  rn as PLAY,
  jn as PLAYBACK_SPEED,
  Rn as PLAYBACK_SPEED_MESSAGE,
  On as PREVIOUS_CAPTION_LANGUAGE,
  In as PREVIOUS_HIT,
  pn as QUALITY,
  Pn as QUALITY_MENU,
  Cn as REPLAY,
  un as RESET_PLAYBACK_SPEED,
  vn as RIGHT_ARROW,
  dn as SEARCH_TRANSCRIPT_PLACEHOLDER,
  Un as SECONDS,
  Ln as SECONDS_other,
  Dn as SEEK_BACKWARD,
  kn as SEEK_FORWARD,
  ln as SETTINGS,
  mn as SHORTCUT,
  Mn as SIDEBAR,
  zn as SPACE,
  Gn as SPEED_MENU,
  Yn as START_AUTOSCROLL,
  bn as TOGGLE_CAPTIONS,
  Vn as TOGGLE_MUTED,
  Hn as TOGGLE_PLAY_PAUSE,
  Bn as TRANSCRIPT_LINES,
  hn as TRANSCRIPT_LINES_other,
  gn as TRANSCRIPT_LOADING,
  Kn as TRANSCRIPT_LOAD_ERROR,
  Zn as TRANSCRIPT_OPTIONS,
  Fn as TRANSCRIPT_RETRY,
  Jn as TRANSCRIPT_UNAVAILABLE,
  Wn as UP_ARROW,
  $n as VIDEO_SETTINGS,
  Qn as VOLUME,
  xn as VOLUME_VALUE,
  Xn as default
};
